import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import reportBuilderAPIClientFactory from "../../backend/reportBuilderAPIClient";
import apiClientFactory from "../../backend/apiClient";
import endpoints from "../../backend/reportAPIEndpoints";

// Edit rule api call
function* updateRuleStartHandlerSaga(action) {
	const apiClient = apiClientFactory();
	const { rule_id, requestBody } = action.payload;
	try {
		const { data } = yield call(
			apiClient.put,
			endpoints.updateRule(rule_id),
			requestBody,
		);
		yield put({
			type: types.UPDATE_RULE_FOR_ENTITY_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.UPDATE_RULE_FOR_ENTITY_ERROR,
			payload,
		});
	}
}
export function* updateRuleStartWatcherSaga() {
	yield takeLatest(
		types.UPDATE_RULE_FOR_ENTITY_START,
		updateRuleStartHandlerSaga,
	);
}

// Add rule to entity api call
function* addRuleToEntityStartHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.post,
			endpoints.addRule,
			action.payload,
		);
		yield put({
			type: types.ADD_RULE_FOR_ENTITY_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.ADD_RULE_FOR_ENTITY_ERROR,
			payload,
		});
	}
}
export function* addRuleToEntityStartWatcherSaga() {
	yield takeLatest(
		types.ADD_RULE_FOR_ENTITY_START,
		addRuleToEntityStartHandlerSaga,
	);
}

function* getEntityByIdStartHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endpoints.entityById(action.payload),
		);
		yield put({
			type: types.GET_ENTITY_BY_ID_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_GROUPS_ERROR,
			payload,
		});
	}
}
export function* getEntityByIdStartWatcherSaga() {
	yield takeLatest(types.GET_ENTITY_BY_ID_START, getEntityByIdStartHandlerSaga);
}

function* getEntityListHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(apiClient.get, endpoints.entityList);

		yield put({
			type: types.GET_ENTITY_LIST_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_ENTITY_LIST_ERROR,
			payload,
		});
	}
}

export function* getEntityListStartWatcherSaga() {
	yield takeLatest(types.GET_ENTITY_LIST_START, getEntityListHandlerSaga);
}
